import styled from 'styled-components';

import { PAGE_HEIGHT, PAGE_WIDTH } from '@xing-com/crate-lebenslauf-constants';
import { zIndexBackgroundLayer1 } from '@xing-com/layout-tokens';

export const TemplateContainer = styled.div<{
  $colors: {
    primary: string;
    secondary: string;
    text: string;
    textHeader: string;
    textOnPrimary: string;
    textOnSecondary: string;
  };
  $pageMargin?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  $border: boolean;
}>`
  --mainColor: ${({ $colors }) => $colors.primary};
  --color-primary: ${({ $colors }) => $colors.primary};
  --color-secondary: ${({ $colors }) => $colors.secondary};
  --color-text: ${({ $colors }) => $colors.text};
  --color-textHeader: ${({ $colors }) => $colors.textHeader};
  --color-textOnPrimary: ${({ $colors }) => $colors.textOnPrimary};
  --color-textOnSecondary: ${({ $colors }) => $colors.textOnSecondary};
  --sectionHeaderTopMargin: 25px;
  --pageMarginLeft: ${({ $pageMargin }) =>
    $pageMargin?.left ? `${$pageMargin.left}px` : '60px'};
  --pageMarginTop: ${({ $pageMargin }) =>
    $pageMargin?.top
      ? `${$pageMargin.top}px`
      : 'calc(40px - var(--sectionHeaderTopMargin))'};
  --pageMarginRight: ${({ $pageMargin }) =>
    $pageMargin?.right ? `${$pageMargin.right}px` : '20px'};
  --pageMarginBottom: ${({ $pageMargin }) =>
    $pageMargin?.bottom ? `${$pageMargin.bottom}px` : '35px'};

  position: relative;
  color: var(--color-text);
  height: ${({ $border }) =>
    $border ? `${PAGE_HEIGHT}px` : `${PAGE_HEIGHT + 4}px`};
  width: ${PAGE_WIDTH}px;
  word-break: break-word;
`;

// force white background because we don't want dark theme on the preview
// a position absolute background simplifies to have template backgrounds (e.g. modern)
export const TemplateBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: ${zIndexBackgroundLayer1};
`;

export const PageContainer = styled.div<{
  $visible: boolean;
  $showSinglePage: boolean;
  $border?: string;
}>`
  position: ${({ $showSinglePage }) =>
    $showSinglePage ? 'absolute' : 'relative'};
  height: ${({ $border }) =>
    $border ? `${PAGE_HEIGHT}px` : `${PAGE_HEIGHT + 4}px`};
  width: ${PAGE_WIDTH}px;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  padding: var(--pageMarginTop) var(--pageMarginRight) var(--pageMarginBottom)
    var(--pageMarginLeft);
  overflow: hidden;
  border: ${({ $border }) => $border};
  margin-bottom: ${({ $border }) => ($border ? '4px' : 0)};
`;
export const PageInnerContainer = styled.div`
  height: 100%;
  overflow: hidden;
`;
export const ColumnContainer = styled.div`
  display: flex;
`;
export const Column = styled.div<{
  $columnSize?: string;
  $columnMargin?: number;
  $columnSpacing?: string;
}>`
  width: ${({ $columnSize }) => $columnSize || '50%'};
  margin-right: ${({ $columnSpacing }) => $columnSpacing || '22px'};

  &:last-child {
    margin-right: 0;
  }

  & > :first-child {
    margin-top: ${({ $columnMargin }) =>
      $columnMargin ? $columnMargin + 'px' : '25px'};
  }
`;
